export default __webpack_public_path__ + "static/hfncare-logo-b28724b4635e5f5125b97da55bf0d0b7.png";